/**
 * The Netlise POS sync API (API Gateway, x-api-key).
 *
 * A few dashboard features talk to this rather than the Amplify/Cognito APIs
 * the rest of the app uses: the Uber Eats mapping endpoints, and the shop
 * entitlements endpoint that decides which modules a shop has.
 *
 * UberEatsRepository predates this module and keeps its own copy of the URL and
 * key, plus a request helper that differs on empty and non-JSON bodies. It is
 * left as it is on purpose: changing a working path for tidiness is not worth
 * the risk. New callers should use this one.
 *
 * NOTE ON THE KEY: it ships in the browser bundle, so it is public by nature —
 * true of any key a single-page app sends. It gates the API against casual use,
 * not against someone reading the bundle.
 */

export const POS_API_URL = 'https://8cwdlrhppk.execute-api.ap-southeast-1.amazonaws.com/v1';
export const POS_API_KEY = 'HRLRCy4bWJ3KrKvZY6NTy3lupIwqNVBH81FNMQZM';

export async function posApiRequest(path: string, init?: RequestInit): Promise<any> {
  const res = await fetch(`${POS_API_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': POS_API_KEY,
      ...(init?.headers ?? {}),
    },
  });

  const text = await res.text();
  const body = text ? JSON.parse(text) : null;
  if (!res.ok) {
    throw new Error(body?.message || body?.error || `POS API error (${res.status})`);
  }
  return body;
}
